module.exports = __webpack_public_path__ + "img/ws.svg";